import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "order-group-select-modal-content" }

import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import OrderGroupSelectInput from './OrderGroupSelectInput.vue';
import { i18n } from '@/i18n';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderGroupSelectModal',
  props: {
    isOpening: { type: Boolean },
    title: {},
    description: {},
    nextButtonLabel: {},
    backButtonLabel: {}
  },
  emits: ["next", "back"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;
const props = __props;
const emits = __emit;

// i18n.tがwithDefault内で使えないのでこうしている
const withDefaultBackButtonLabel = computed(() => props.backButtonLabel ?? t('キャンセル'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _ctx.isOpening,
    "next-button-label": _ctx.nextButtonLabel,
    "back-button-label": withDefaultBackButtonLabel.value,
    "enable-outside-click": "",
    "modal-width": 764,
    onOnNext: _cache[0] || (_cache[0] = ($event: any) => (emits('next'))),
    onOnBack: _cache[1] || (_cache[1] = ($event: any) => (emits('back')))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.description), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(OrderGroupSelectInput)
      ])
    ]),
    _: 1
  }, 8, ["modal-state", "next-button-label", "back-button-label"]))
}
}

})